export const PRODUCT_STATUSES = ['inactive', 'trialInSetup', 'trial', 'proInSetup', 'pro'] as const

export type ProductStatus = (typeof PRODUCT_STATUSES)[number]
